import React, {PureComponent as Component} from 'react';
import {MCbrowser} from "../../../Context/browserContext";
import Topics from "../Controllers/Topics";
import TopicInsert from "../Controllers/TopicInsert";
import ShowProfile from "../../../Controllers/Dashboard/ShowProfile";
import ShowFollowingBox from "../../Friend/Controllers/ShowFollowingBox";

class  TopicLayout extends Component{

    componentDidMount() {
        this.context.page.pageBreadcrumbs.current.setCurrent("topics");
        this.context.page.pageBreadcrumbs.current.show(); 
        this.context.page.pageTitle.setTitle("موضوعات شورا راهبردی");
    }

    render() {

        return (
            <>
                <div className="row">
                    <main className="col col-xl-9 order-xl-2 col-lg-12 order-lg-1 col-md-8 col-sm-12 col-12">
                       <TopicInsert />
                       <Topics />
                    </main>
                    <aside className="col col-xl-3 order-xl-1 col-lg-6 order-lg-2 col-md-4 col-sm-12  col-12 side-sticky">
                        <ShowProfile  />
                        <ShowFollowingBox />
                    </aside>
                </div> 
            </>
        ); 
  }
}

TopicLayout.contextType = MCbrowser;

export default TopicLayout;
